import { IonIcon } from '@ionic/react';
import React from 'react';

import { add } from 'ionicons/icons';

import './AddPetButton.scss';
import { AddPetButtonProps } from './types';

const AddPetButton: React.FC<AddPetButtonProps> = ({ onClick }) => {
  return (
    <div className="add-pet-button" onClick={onClick} data-tut="reactour__add_pet_button">
      <div className="add-pet-button__icon">
        <IonIcon icon={add} color="primary" />
      </div>
    </div>
  );
};

export default React.memo(AddPetButton);
